<ng-template #itemTemplate let-item>
    <ng-container *ngIf="item.identifier">{{ item.identifier }}</ng-container>
    <ng-container *ngIf="item.name"> - {{ item.name }}</ng-container>
</ng-template>
<ng-template #selectedItemTemplate let-item>
    <!-- ISO CODE -->
    {{ item?.identifier ?? item }}
    <!-- {{ item | json }} -->
    <!-- {{ item.identifier }} -->
</ng-template>
